/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalSingleBurnerComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalSingleBurner').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'BURNER_SINGLE_LYNX_PROFESSIONAL_LSB13',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-single-burner.js.map